import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { isSupabaseConfigured } from "../supabase/client";
import "./admin.css";

const friendlyError = (err) => {
  const msg = (err && err.message) || "";
  if (/invalid login credentials/i.test(msg)) return "Incorrect email or password.";
  if (/email not confirmed/i.test(msg)) return "This account's email hasn't been confirmed yet.";
  if (/rate limit|too many/i.test(msg)) return "Too many attempts. Please wait a moment and try again.";
  if (/network|fetch/i.test(msg)) return "Network error. Check your connection and try again.";
  return "Could not sign in. Please try again.";
};

const Login = () => {
  const { currentUser, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  // Already signed in → go straight to the dashboard.
  if (currentUser) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate("/admin");
    } catch (err) {
      setError(friendlyError(err));
      setBusy(false);
    }
  };

  return (
    <div className="admin-root">
      <div className="admin-login-wrap">
        <div className="admin-login-card">
          <h1>Softwood <span style={{ color: "#b07d4f" }}>Admin</span></h1>
          <p className="sub">Sign in to manage site content.</p>

          {!isSupabaseConfigured && (
            <div className="config-warning">
              Supabase isn't configured yet. Add your keys to <code>.env</code> and
              restart to enable sign-in.
            </div>
          )}

          {error && <div className="admin-alert error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="admin-field">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
            <div className="admin-field">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>
            <button
              className="btn btn-primary btn-block"
              type="submit"
              disabled={busy || !isSupabaseConfigured}
            >
              {busy ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
